<y42-smart-btn
  data-test="button-hard-reset"
  type="button"
  [pending]="state.resetting"
  [style]="'dark'"
  (click)="hardReset()"
>
  {{ state.resetting ? 'Resetting App... Please wait.' : 'Reset App' }}
</y42-smart-btn>
